
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor1 as ObiResistor1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-1.js';
 
 
 

 
 export const ObiResistor1 = createComponent({
   react: React,
   tagName: 'obi-resistor-1',
   elementClass: ObiResistor1Element,
   events: {
     
   }
  });
 
 